import {AppSettings} from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

let API_URI = AppSettings.CURRENT_SITE_URI;
let api = 'api';

//check admin or builder, true is admin
if (AppSettings.CURRENT_SITE_URI === AppSettings.SITE_ONE_SERVICE_URI) {
  API_URI = AppSettings.GLOBAL_API_URL;
  api = 'apiv1';
}

export const searchRooms = (params) => {

  return Jwt(API_URI).get(`/${api}/rooms/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListRooms = (params) => {

  return Jwt(API_URI).get(`/${api}/rooms/rooms-select-list?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getById = (params) => {

  return Jwt(API_URI).get(`/${api}/rooms/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addRoom = (params) => {

  return Jwt(API_URI).post(`/${api}/rooms`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editRoom = (params) => {

  return Jwt(API_URI).put(`/${api}/rooms?${ObjToParam(params.query)}`, params.param)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeActive = (params) => {

  return Jwt(API_URI).put(`/${api}/rooms/${params.id}/active`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const makeInActive = (params) => {

  return Jwt(API_URI).put(`/${api}/rooms/${params.id}/inactive`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const fetchHomeownerRoomSelectList = (params) => {
  return Jwt(null, false, {headers: [{key: params.headers.key, value: params.headers.value}]}).get(`${params.endpoint}/api/portal-homeowners/${params.lotId}/rooms-select-list`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};




// WEBPACK FOOTER //
// ./src/Rooms/api.js